import React from "react";

const menuGroups = [
  {
    name: "Salate",
    items: [
      {
        name: "Paradajz",
        description: "sa lukom ili bez luka",
        amount: "250 g",
        price: "320 rsd"
      },
      {
        name: "Svež krastavac",
        amount: "200 g",
        price: "320 rsd"
      },
      {
        name: "Svež kupus",
        amount: "250 g",
        price: "300 rsd"
      },
      {
        name: "Kiseli kupus",
        amount: "300 g",
        price: "340 rsd"
      },
      {
        name: "Srpska salata",
        amount: "300 g",
        price: "360 rsd"
      },
      {
        name: "Šopska salata",
        amount: "350 g",
        price: "400 rsd"
      },
      {
        name: "Belolučena paprika",
        amount: "250 g",
        price: "380 rsd"
      },
      {
        name: "Tarator salata",
        description: "svež krastavac, beli luk, pavlaka",
        amount: "300 g",
        price: "370 rsd"
      },
      {
        name: "Grčka salata",
        description:
          "paradajz, krastavac, zelena salata, crni luk, masline, origano, feta sir",
        amount: "400 g",
        price: "500 rsd"
      },
      {
        name: "Ajvar",
        amount: "150 g",
        price: "370 rsd"
      },
      {
        name: "Mešana salata",
        description: "po izboru",
        amount: "300 g",
        price: "370 rsd"
      },
      {
        name: "Turšija",
        amount: "300 g",
        price: "320 rsd"
      },
      {
        name: "Cvekla",
        amount: "250 g",
        price: "320 rsd"
      },
      {
        name: "Barena paprika",
        amount: "250 g",
        price: "280 rsd"
      },
      {
        name: "Krompir salata",
        description: "bareni krompir, crni luk, začini",
        amount: "300 g",
        price: "300 rsd"
      },
      {
        name: "Zelena salata",
        amount: "200 g",
        price: "320 rsd"
      },
      {
        name: "Salata \"Krčma\"",
        amount: "300 g",
        price: "500 rsd"
      },
      {
        name: "Vitaminska salata",
        amount: "200 g",
        price: "420 rsd"
      },
      {
        name: "Ljuta papričica",
        amount: "kom.",
        price: "70 rsd"
      },
      {
        name: "\"Krčma\" salata",
        description: "paradajz, krastavac, majonez, pavlaka, pršuta",
        amount: "300 g",
        price: "500 rsd"
      }
    ]
  },
  {
    name: "Topla predjela",
    items: [
      {
        name: "Pečurke na žaru",
        amount: "400 g",
        price: "500 rsd"
      },
      {
        name: "Pohovane pečurke",
        description: "pečurke, jaja",
        amount: "400 g",
        price: "550 rsd"
      },
      {
        name: "Omlet (sir, šunka, slanina)",
        description: "3 jajeta, dodatak",
        amount: "400 g",
        price: "420 rsd"
      },
      {
        name: "Kajgana",
        description: "od 3 jajeta",
        amount: "300 g",
        price: "330 rsd"
      },
      {
        name: "Bekendeks",
        description: "3 jajeta, slanina",
        amount: "400 g",
        price: "420 rsd"
      },
      {
        name: "Hemendeks",
        description: "3 jajeta, šunka",
        amount: "400 g",
        price: "420 rsd"
      },
      {
        name: "Pohovani kačkavalj",
        description: "kačkavalj, prezla, jaja",
        amount: "300 g",
        price: "490 rsd"
      },
      {
        name: "Pohovana paprika",
        description: "brašno, paprika, jaja",
        amount: "300 g",
        price: "490 rsd"
      },
      {
        name: "Pohovane palačinke",
        description: "dve palačinke, kačkavalj, šunka, jaja, prezle",
        amount: "400 g",
        price: "630 rsd"
      },
      {
        name: "Kačamak",
        description: "sir, kajmak",
        amount: "400 g",
        price: "370 rsd"
      },
      {
        name: "Paprika na kajmaku",
        amount: "300 g",
        price: "350 rsd"
      },
      {
        name: "Špageti bolonez",
        description: "mleveno svinjsko meso, paradajz pelat",
        price: ""
      }
    ]
  },
  {
    name: "Čorbe",
    items: [
      {
        name: "Juneća čorba",
        description: "juneće meso, povrće, brašno, začini",
        price: "350 rsd"
      },
      {
        name: "Jagnjeća čorba",
        description: "jagnjeće meso, povrće, brašno, začini, aleva paprika",
        price: ""
      },
      {
        name: "Riblja čorba",
        description: "riblje meso, povrće",
        price: "300 rsd"
      },
      {
        name: "Čorba od vrganja",
        description: "vrganj, povrće, začini",
        price: ""
      }
    ]
  },
  {
    name: "Jela sa roštilja",
    items: [
      {
        name: "Ćevapi",
        description: "mleveno svinjsko i juneće meso, začini",
        amount: "350 g",
        price: "800 rsd"
      },
      {
        name: "Pljeskavica",
        description: "mleveno svinjsko i juneće meso, začini, crni luk",
        amount: "350 g",
        price: "800 rsd"
      },
      {
        name: "Pljeskavica na kajmaku",
        description: "mleveno svinjsko i juneće meso, začini, kajmak, crni luk",
        amount: "350 g",
        price: "920 rsd"
      },
      {
        name: "Gurmanska pljeskavica",
        description:
          "mleveno svinjsko i juneće meso, kačkavalj, crni luk, beli luk, slanina, ljuta paprika",
        amount: "400 g",
        price: "920 rsd"
      },
      {
        name: "Punjena pljeskavica",
        description: "mleveno svinjsko i juneće meso, začini, kačkavalj, šunka",
        amount: "400 g",
        price: "800 rsd"
      },
      {
        name: "Svinjski ražnjić (2 kom.)",
        description: "svinjsko meso, začini",
        amount: "300 g",
        price: "900 rsd"
      },
      {
        name: "Bela vešalica",
        description: "svinjsko meso, začini",
        amount: "300 g",
        price: "760 rsd"
      },
      {
        name: "Rolovani svinjski ražnjić",
        description: "svinjsko meso, začini, slanina",
        amount: "350 g",
        price: "980 rsd"
      },
      {
        name: "Dimljena vešalica",
        amount: "300 g",
        price: ""
      },
      {
        name: "Dimljeni vrat",
        description: "dimljen svinjski vrat, začini",
        amount: "1 kg",
        price: "2500 rsd"
      },
      {
        name: "Mešano meso",
        description:
          "svinjski ražnjić, svinjska i pileća šnicla, pljeskavica, ćevapi, kobasica, slanina",
        amount: "550 g",
        price: "800 rsd"
      },
      {
        name: "Punjena vešalica",
        description: "svinjsko meso, začini, kačkavalj, šunka",
        amount: "350 g",
        price: "1020 rsd"
      },
      {
        name: "Teleći medaljoni sa prelivom od pečuraka",
        description: "teleće meso, začini, pečurke, crni luk, slanina",
        amount: "350 g",
        price: ""
      },
      {
        name: "Kobasica \"Krčma\"",
        amount: "1 kg",
        price: ""
      },
      {
        name: "Dimljeni file \"Krčma\"",
        amount: "300 g",
        price: ""
      },
      {
        name: "Teleći biftek",
        amount: "300 g",
        price: "1980 rsd"
      },
      {
        name: "Domaća slanina",
        amount: "300 g",
        price: "760 rsd"
      }
    ]
  },
  {
    name: "Deserti",
    items: [
      {
        name: "Palačinke (2 kom.)",
        description: "džem, med, krem, orasi, plazma keks",
        price: "310 rsd"
      },
      {
        name: "Voćna salata",
        description: "mešano voće, voćni sok, šlag",
        price: "340 rsd"
      },
      { name: "Baklava", price: "270 rsd" },
      { name: "Tulumbići", price: "" },
      {
        name: "Palačinke u šatou",
        description: "minimum 2 porcije",
        price: "570 rsd"
      },
      { name: "Sladoled", price: "" },
      { name: "Domaći kolač", price: "" }
    ]
  },
  {
    name: "Hleb i peciva",
    items: [
      { name: "Lepinja", price: "70 rsd" },
      { name: "Prepečena lepinja", price: "100 rsd" },
      { name: "Proja", price: "50 rsd" },
      { name: "Lepinja sa šunkom i kajmakom", price: "320 rsd" },
      { name: "Lepinja sa pršutom", price: "380 rsd" },
      { name: "Prženice", price: "280 rsd" }
    ]
  },
  {
    name: "Bezalkoholna pića",
    items: [
      { name: "Limunada", amount: "0.3 l", price: "200 rsd" },
      { name: "Ceđena pomorandža", amount: "0.3 l", price: "300 rsd" },
      { name: "Guarana", amount: "0.25 l", price: "200 rsd" },
      { name: "Red Bull", amount: "0.25 l", price: "300 rsd" },
      { name: "Fanta", amount: "0.25 l", price: "200 rsd" },
      { name: "Coca-Cola", amount: "0.25 l", price: "200 rsd" },
      { name: "Coca-Cola \"Zero\"", amount: "0.25 l", price: "200 rsd" },
      { name: "Kokta", amount: "0.25 l", price: "200 rsd" },
      { name: "Tonic", amount: "0.25 l", price: "200 rsd" },
      { name: "Sprite", amount: "0.25 l", price: "200 rsd" },
      { name: "Bitter lemon", amount: "0.25 l", price: "200 rsd" }
    ]
  },
  {
    name: "Sokovi",
    items: [
      { name: "Breskva", amount: "0.2 l", price: "200 rsd" },
      { name: "Pomorandža", amount: "0.2 l", price: "200 rsd" },
      { name: "Jagoda", amount: "0.2 l", price: "200 rsd" },
      { name: "Jabuka", amount: "0.2 l", price: "200 rsd" },
      { name: "Borovnica", amount: "0.2 l", price: "200 rsd" },
      { name: "Kajsija", amount: "0.2 l", price: "" },
      { name: "Ananas", amount: "0.2 l", price: "" },
      { name: "Cedevita", amount: "0.375 l", price: "250 rsd" }
    ]
  },
  {
    name: "Vode",
    items: [
      { name: "Rosa", amount: "0.33 l", price: "150 rsd" },
      { name: "Akva Viva", amount: "0.25 l", price: "150 rsd" },
      { name: "Knjaz Miloš", amount: "0.25 l", price: "150 rsd" },
      { name: "Voda Vrnci", amount: "0.25 l", price: "" },
      { name: "Knjaz Miloš", amount: "1 l", price: "250 rsd" },
      { name: "Voda Vrnci", amount: "1 l", price: "" },
      { name: "Rosa", amount: "0.75 l", price: "" },
      { name: "Voda Voda", amount: "0.7 l", price: "200 rsd" },
      { name: "Voda Voda", amount: "0.3 l", price: "150 rsd" }
    ]
  },
  {
    name: "Kafe i topli napici",
    items: [
      { name: "Domaća kafa", price: "150 rsd" },
      { name: "Espresso", price: "170 rsd" },
      { name: "Espresso sa mlekom", price: "180 rsd" },
      { name: "Nescafe", price: "200 rsd" },
      { name: "Capuccino", price: "180 rsd" },
      { name: "Topla čokolada", price: "" },
      { name: "Mleko", price: "10 rsd" },
      { name: "Čaj domaći", price: "180 rsd" },
      { name: "Kuvano vino", price: "190 rsd" },
      { name: "Kuvana rakija", price: "140 rsd" }
    ]
  },
  {
    name: "Žestoka pića",
    items: [
      { name: "Domaća rakija", amount: "0.03 l", price: "150 rsd" },
      { name: "Pelinkovac", amount: "0.03 l", price: "200 rsd" },
      { name: "Stomaklija", amount: "0.03 l", price: "160 rsd" },
      { name: "Vinjak", amount: "0.03 l", price: "200 rsd" },
      { name: "Smirnof vodka", amount: "0.03 l", price: "170 rsd" },
      { name: "Viljamovka", amount: "0.03 l", price: "250 rsd" },
      { name: "Kajsijevaca", amount: "0.03 l", price: "250 rsd" },
      { name: "Dunjevaca", amount: "0.03 l", price: "250 rsd" },
      { name: "Žuta osa", amount: "0.03 l", price: "240 rsd" },
      { name: "Bela osa", amount: "0.03 l", price: "240 rsd" },
      { name: "Lincura", amount: "0.03 l", price: "250 rsd" },
      { name: "Stock", amount: "0.03 l", price: "180 rsd" },
      { name: "Jegger", amount: "0.03 l", price: "200 rsd" },
      { name: "Jack Daniels whiskey", amount: "0.03 l", price: "350 rsd" },
      { name: "Ballantine's whiskey", amount: "0.03 l", price: "200 rsd" },
      { name: "Johnnie Walker whiskey", amount: "0.03 l", price: "250 rsd" },
      { name: "Chivas whiskey", amount: "0.03 l", price: "350 rsd" },
      { name: "Klekovača", amount: "0.03 l", price: "200 rsd" },
      { name: "Mastika", amount: "0.03 l", price: "170 rsd" },
      { name: "Stara Sokolova", amount: "0.03 l", price: "" },
      { name: "Gružanska nit", amount: "0.03 l", price: "200 rsd" },
      { name: "Loza", amount: "0.03 l", price: "200 rsd" },
      { name: "Vinjak 5", amount: "0.03 l", price: "200 rsd" },
      { name: "Tekila", amount: "0.03 l", price: "170 rsd" },
      { name: "Konjak", amount: "0.03 l", price: "" },
      { name: "Vodka crna", amount: "0.03 l", price: "" },
      { name: "Dudovača", amount: "0.03 l", price: "" },
      { name: "Medovača", amount: "0.03 l", price: "170 rsd" },
      { name: "Drenovka", amount: "0.03 l", price: "200 rsd" }
    ]
  },
  {
    name: "Aromatizovana pića",
    items: [
      { name: "Vermut", amount: "0.1 l", price: "200 rsd" },
      { name: "Čoko-liker", amount: "0.03 l", price: "" },
      { name: "Baileys", amount: "0.03 l", price: "230 rsd" },
      { name: "Džin", amount: "0.03 l", price: "180 rsd" },
      { name: "Maartini", amount: "0.1 l", price: "240 rsd" }
    ]
  },
  {
    name: "Piva",
    items: [
      { name: "Jelen pivo", amount: "0.5 l", price: "200 rsd" },
      { name: "Lav pivo", amount: "0.5 l", price: "" },
      { name: "Staropramen", amount: "0.5 l", price: "" },
      { name: "Nikšićko pivo", amount: "0.5 l", price: "200 rsd" },
      { name: "Zaječarsko", amount: "0.5 l", price: "200 rsd" },
      { name: "Jelen pivo", amount: "0.33 l", price: "" },
      { name: "Lav pivo", amount: "0.33 l", price: "" },
      { name: "Staropramen", amount: "0.33 l", price: "" },
      { name: "Nikšićko pivo (tamno)", amount: "0.33 l", price: "" },
      { name: "Tuborg", amount: "0.33 l", price: "250 rsd" },
      { name: "Heineken", amount: "0.25 l", price: "250 rsd" },
      { name: "Bavaria", amount: "0.25 l", price: "250 rsd" },
      { name: "Zaječarsko", amount: "0.33 l", price: "210 rsd" },
      { name: "Jelen Fresh", amount: "0.33 l", price: "" },
      { name: "Somersby", amount: "0.33 l", price: "260 rsd" },
      { name: "Kvas", amount: "0.33 l", price: "" },
      { name: "Carling", amount: "0.33 l", price: "" },
      { name: "Steela", amount: "0.33 l", price: "250 rsd" },
      { name: "Heineken", amount: "0.4 l", price: "250 rsd" }
    ]
  }
];

export function MenuSection() {
  const menuOrder = [
    "Salate",
    "Topla predjela",
    "Čorbe",
    "Jela sa roštilja",
    "Deserti",
    "Hleb i peciva",
    "Bezalkoholna pića",
    "Sokovi",
    "Vode",
    "Kafe i topli napici",
    "Žestoka pića",
    "Aromatizovana pića",
    "Piva"
  ];

  const orderedGroups = menuOrder
    .map((name) => menuGroups.find((group) => group.name === name))
    .filter(Boolean);

  return (
    <section className="section section-alt restaurant-page">
      <div className="section-inner">
        <header className="section-header">
          <p className="section-eyebrow">Restoran</p>
          <h1 className="section-title">Meni i cenovnik</h1>
          <p className="section-subtitle">
            Svako jelo pripremamo od pažljivo biranih namirnica, po receptima
            koji se prenose sa kolena na koleno. Uživajte u ukusu prave
            domaće kuhinje.
          </p>
        </header>

        <div className="restaurant-menu-section menu-parchment">
          <h2 className="menu-section-heading">Proizvodi i cene</h2>
          <div className="menu-grid">
            {orderedGroups.map((group) => (
              <div key={group.name} className="menu-group">
                <h3>{group.name}</h3>
                <ul>
                  {group.items.map((item) => (
                    <li key={item.name} className="menu-item">
                      <div className="menu-item-main">
                        <div className="menu-item-heading">
                          <span className="menu-item-name">
                            {item.name}
                            {item.amount && (
                              <span className="menu-item-amount">
                                {" "}
                                ({item.amount})
                              </span>
                            )}
                          </span>
                        </div>
                        {item.description && (
                          <p className="menu-item-description">
                            {item.description}
                          </p>
                        )}
                      </div>
                      <span className="menu-item-price">
                        {item.price || ""}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

